import type { ThemeKey } from '@/app/theme/resolveTheme'
import { VARIANT } from '@/src/utils/buildUtils'

import { featureConfig, type Features } from './index'

// Per-request overlay on top of the build-time brand config.
//
// `featureConfig` is keyed by NEXT_PUBLIC_VARIANT, which is fixed at build time. A sub-brand
// like heya is the same FLYIN build served on a different host (see app/theme/resolveTheme.ts),
// so it cannot be a VariantType — it layers over one instead.
//
// Only put on/off switches here. Content swaps, API request params and brand identity stay
// explicit isHeya checks: they are not "is this feature enabled" questions.
const themeFeatureOverrides: Partial<Record<ThemeKey, Partial<Features>>> = {
    heya: {
        OFFERS: false,
        MEDIA_FLOATER: false,
        FLIGHTS_HOTELS: false,
        HOME_PROMO_CARDS: false,
        POPULAR_HOTELS: false,
        // Footer SEO rows and the Flyin app card are brand-wide and carry international
        // content; heya is Saudi-only.
        TOP_DESTINATIONS: false,
        TOP_COUNTRIES: false,
        TOP_AIRLINES: false,
        APP_DOWNLOAD_BANNER: false,
        // Heya-only vertical; no brand config enables it.
        EXPERIENCE: true
    }
}

export const resolveFeatures = (themeKey: ThemeKey): Partial<Features> => ({
    ...featureConfig[VARIANT],
    ...themeFeatureOverrides[themeKey]
})
